import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { PREMIER_AUTHFAILURE_REDIRECT, PREMIER_AUTHFAILURE_LINKURL } from 'config';
import { BaseProfileModel } from 'lib/ng2-sapmp/src/models';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ProductModel, MDMDetails } from './../../models/product';
import { HeaderService } from './../header/header.service';

import { ADDP_PERMISSION_MAPPING } from 'config';
declare var ENV_PORTAL: any;
declare var logoutCurrentUser: Function;
@Component({
  selector: 'app-authorizing',
  template: '<h1></h1>',
  styleUrls: ['./authentication.component.scss'],
  providers: [AuthenticationService]
})

export class AuthenticationComponent implements OnInit, OnDestroy {
  jwtToken: string;
  user: BaseProfileModel;
  permissions: any;
  userPermission: any;
  rkey: any;
  loginFailure: any;
  dummyPerm: any;
  clientIPAddress: any;
  adminAttId: string;
  source: string;
  optout: string;
  mdmDetails: MDMDetails;
  
  constructor(route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private util: UtilityService,
    private pageloaderService: PageLoaderService,
    private breadCrumbService: BreadCrumbService, private headerService: HeaderService) {

    if (history.length > 1 && this.authenticationService.checkIfAuthNeeded()) {
      history.back();
    } else {
      this.pageloaderService.setPageLoaderStatus(false);
      this.mdmDetails = new MDMDetails();
      ({ 'token': this.jwtToken } = route.snapshot.queryParams);
      ({ 'rKey': this.rkey } = route.snapshot.queryParams);
      ({ 'result': this.loginFailure } = route.snapshot.queryParams);
      ({ 'clientIPAddress': this.clientIPAddress } = route.snapshot.queryParams);
      ({ 'source': this.source } = route.snapshot.queryParams);
      ({ 'optout': this.optout } = route.snapshot.queryParams);
      ({ 'adminAttId': this.adminAttId } = route.snapshot.queryParams);
      sessionStorage.setItem('emailStatus', this.optout);
      if (this.loginFailure) {
        console.log('authentication.component:57');
        this.handleLoginError();
      } else {
        this.jwtToken ? sessionStorage.setItem('sapmp_jwtToken', this.jwtToken) : null;
        let profileMock = "";
        profileMock = localStorage.getItem('profileFail') ? JSON.parse(localStorage.getItem('profileFail')) : false;
        
        this.authenticationService.getProfile(this.adminAttId)
          .subscribe(respobj => {
            sessionStorage.setItem('profileAndPermsInfo', JSON.stringify(respobj));
            sessionStorage.setItem('sapmp_jwtToken', respobj.jwtToken);
            sessionStorage.setItem('impersonator', JSON.stringify(respobj.profile.impersonator));
            
            //mock for profileAndPermsInfo call - to redorect to login page if any field is missing in the response
            if(profileMock){
              delete respobj.permissions;
            }
            //end of mock
            this.permissions = respobj.permissions;
            const profile = respobj.profile;
            if (this.permissions) {

              if (!this.source) {
                this.source = 'premier';
              }

              if (profile && profile.user) {
                this.user = this.authenticationService.getProfileModel(profile);
                this.user.clientIPAddress = this.clientIPAddress;
                if (!sessionStorage.getItem('sessionId')) {
                  sessionStorage.setItem('sessionId', profile.user.sessionId);
                }

                if (this.user.addpAuthority !== 'NONE') {
                  this.authenticationService.getFanSignedUpStatus()
                    .subscribe(resp => {
                      sessionStorage.setItem("accountSummaryData", JSON.stringify(resp));
                      sessionStorage.setItem('initialSignupStatus', resp.initialSignupStatus);
                      sessionStorage.setItem('noOfDevice', resp.noOfDevices);
                      //sessionStorage.setItem('noOfFans', resp.noOfFans);
                      console.log("accountSummary called 1st time....");
                      if (!resp.efotaFansSummary) {
                        sessionStorage.setItem('efotaEnrolledFanList', '[]');
                        sessionStorage.setItem('efotaEnrollmentInfo', '[]');
                      }
                      else {
                        let efotaFansSum = resp.efotaFansSummary;
                        let efotaEnrolledFanList = [];
                        for (let i = 0; i < efotaFansSum.length; i++) {
                          if (efotaFansSum[i].status == "ACTIVE") {
                            for (let j = 0; j < efotaFansSum[i].count; j++) {
                              efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                            }
                          }
                        }
                        sessionStorage.setItem('efotaEnrolledFanList', JSON.stringify(efotaEnrolledFanList));
                      }
                      if (!resp.efotaNotEnrolledFanList) {
                        sessionStorage.setItem('efotaNotEnrolledFanList', '[]');
                      }
                      else {
                        sessionStorage.setItem('efotaNotEnrolledFanList', JSON.stringify(resp.efotaNotEnrolledFanList));
                        sessionStorage.setItem('efotaEnrollmentInfo', JSON.stringify(resp.efotaEnrollmentInfo));
                      }

                      if (resp.allFansInEligible === true) {
                        this.user.fanSignedUpStatus = 'NotEligible';
                        // if(resp.noOfFans == 0 && resp.noOfDevices == 0){
                        //   this.user.fanSignedUpStatus = 'Unknown';
                        // }
                      } else {
                        if (resp.fansSummary.length > 0) {
                          let signupFanSum = resp.fansSummary;
                          let signupFanList = [];
                          let inProgressFan = [];
                          let processingFanList = [];
                          for (let i = 0; i < signupFanSum.length; i++) {
                            if (signupFanSum[i].status == "AWAITING_SIGNUP") {
                              for (let j = 0; j < signupFanSum[i].count; j++) {
                                signupFanList.push(signupFanSum[i].fans[j]);
                              }
                            }
                          }
                          sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));

                          //set active fans list
                          let signupActiveFanList = [];
                          for (let i = 0; i < signupFanSum.length; i++) {
                            if (signupFanSum[i].status == "ACTIVE") {
                              for (let j = 0; j < signupFanSum[i].count; j++) {
                                signupActiveFanList.push(signupFanSum[i].fans[j]);
                              }
                            }
                          }
                          sessionStorage.setItem('signupActiveFanList', JSON.stringify(signupActiveFanList));

                          //for 'processing' fans
                          for (let i = 0; i < signupFanSum.length; i++) {
                            if (signupFanSum[i].status == "PROCESSING") {
                              for (let j = 0; j < signupFanSum[i].count; j++) {
                                //processingFanList.push(signupFanSum[i].fans[j]);
                                inProgressFan.push(signupFanSum[i].fans[j]);
                                //getting fan info of 'processing' fan to store in session storage
                                for (let k = 0; k < resp.fanInfoList.length; k++) {
                                  if (signupFanSum[i].fans[j] === resp.fanInfoList[k].fan) {
                                    processingFanList.push(resp.fanInfoList[k]);
                                  }
                                }
                              }
                            }
                          }
                          sessionStorage.setItem('processingFanList', JSON.stringify(processingFanList));
                          sessionStorage.setItem('inProgressFan', JSON.stringify(inProgressFan));
                        }
                        if (this.user) {
                          this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
                        }
                        if (resp.productCode !== null && resp.productCode !== undefined) {
                          this.mdmDetails.productCode = resp.productCode;
                          this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
                          if (this.mdmDetails.productCode === 'ADDPMDM') {
                            this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                            let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                            productDetails.emmProductCode = 'ADDPMDM';
                            productDetails.selectedAccID = resp.ibmEmmAccountId;
                            productDetails.signupEmmStatus = 'revised';
                            sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                          } else {
                            if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                              this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                            }
                            if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                              this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                            }
                            // if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                            //   sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                            //  }
                          }

                          sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
                        }
                      }
                      if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                        sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                      }
                      this.authenticationService.setUser(this.user);
                      sessionStorage.setItem('permissions', JSON.stringify(this.permissions));
                      //Logic for Register/Enroll menu hide if users has no FANs left for enroll.
                      let enrollData = {noOfFans: resp.noOfFans, fanInfoList: resp.fanInfoList};
                      this.authenticationService.updateEnrollStatus(enrollData);
                      this.loginSuccessRedirect();
                    }, () => {
                      this.user.fanSignedUpStatus = 'Error';
                      this.authenticationService.setUser(this.user);
                      sessionStorage.setItem('initialSignupStatus', 'unknown');
                      sessionStorage.setItem('noOfDevice', 'unknown');
                      sessionStorage.setItem('permissions', JSON.stringify(this.permissions));
                      this.loginSuccessRedirect();
                    });
                } else {
                  this.authenticationService.setUser(this.user);
                  sessionStorage.setItem('initialSignupStatus', 'unknown');
                  sessionStorage.setItem('noOfDevice', 'unknown');
                  sessionStorage.setItem('permissions', JSON.stringify(this.permissions));
                  this.loginSuccessRedirect();
                }

              } else {
                console.log('authentication.component:169');
                this.authenticationService.handleLoginError('403');
              }
            } else {
              console.log('authentication.component:173');
              this.authenticationService.handleLoginError('403');
            }
          }, (e) => {
            console.dir(e);
            console.log('authentication.component:178');
            this.authenticationService.handleLoginError('403');
          });
      }
    }

  }


  ngOnInit() {
  }

  handleLoginError() {
    /** need to handle error scenarios */
    this.pageloaderService.setPageLoaderStatus(true);
    this.authenticationService.setDefaultUser();
    this.router.navigate(['errorPage', 'loginFailure']);
  };

  loginSuccessRedirect() {
    let sourceRoute = this.rkey ? this.rkey
      : this.authenticationService.getLoginSuccessUrl();
    this.authenticationService.setLoginSuccessUrl(undefined);

    if (sourceRoute === 'srHome' || sourceRoute.includes('login') || sourceRoute.includes('home')) {
      sourceRoute = 'home';
    }
    const [sourcePage, id] = sourceRoute.split('/').filter(v => v !== '');

    const hasPremission = this.util.checkPagePermission(sourcePage, this.permissions.perm);
    this.pageloaderService.setPageLoaderStatus(true);

    // to do addp permission check
    const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
    const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
    if (redirectInfo) {
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    }

    if (sessionStorage.getItem('eligibilityCheck')) {
      if (redirectInfo.message !== null) {
        this.router.navigate([redirectInfo.logonurl], { queryParams: { modalRedirect: true } });
      } else {
        this.router.navigate([redirectInfo.logonurl]);
      }
      sessionStorage.removeItem('eligibilityCheck');
    } else {
      if (hasPremission) {
        /**
         * Code for to check product already purchased or not
         */
        const filterUrl = this.breadCrumbService.filterCurrentUrl('/' + sourceRoute);
        if ((sessionStorage.getItem('sapmp_jwtToken') !== null) && (filterUrl === 'productConfigurator')) {
          this.getSubscriptionData(sourceRoute);
        } else {
          //redirect from login to faq or support based on what user has selected
          let isSupportClicked = this.authenticationService.getCookie('support');
          let isFaqClicked = this.authenticationService.getCookie('faq');
          let isManageInventoryClicked = this.authenticationService.getCookie('manageInventory');
          let isProductSelectionClicked = this.authenticationService.getCookie('productselection');
          if (isSupportClicked) {
            this.deleteFaqSupportCookies('support');
            this.router.navigate(['/support']);
          } else if (isFaqClicked) {
            this.deleteFaqSupportCookies('faq');
            this.router.navigate(['/faq']);
          } else if (isManageInventoryClicked) {
            this.deleteFaqSupportCookies('manageInventory');
            this.router.navigate(['/manageInventory']);
          }else if (isProductSelectionClicked) {
            this.router.navigate(['/home']);
          } else {
            this.router.navigate([sourceRoute]);
          }

        }

      } else {
        const redirectPage = PREMIER_AUTHFAILURE_REDIRECT[sourcePage];
        if (!redirectPage) {
          this.router.navigate(['errorPage/403']);
        } else {
          const redirectRoute = redirectPage + (id ? '/' + id : '');
          const linkUrl = PREMIER_AUTHFAILURE_LINKURL[this.user.permission];
          this.router.navigate([redirectRoute], { queryParams: { modalRedirect: linkUrl } });
        }
      }
    }
  }

  ;

  private getSubscriptionData(sourceRoute) {
    this.pageloaderService.setPageLoaderStatus(false);
    const productId = this.authenticationService.getLoginSuccessUrl().split('/').find(data => (data !== 'productConfigurator'));
    let productDetail = new ProductModel();
    productDetail = JSON.parse(sessionStorage.getItem('productConfig-' + productId));
    if (productDetail) {
      const subscriptionRequestModel = { 'serviceStatus': 'ACTIVE', 'serviceOfferCodes': [] };
      const requestobj = {};
      productDetail.skus.forEach(element => {
        requestobj[element.socCode] = element.id;
      });
      subscriptionRequestModel.serviceOfferCodes.push(requestobj);
      const url = (this.util.getEnvConfig().subscriptionUrl).replace('{companyid}', this.user.companyId);
      this.authenticationService.getSubscriptionData(url, subscriptionRequestModel)
        .subscribe(subResponse => {
          let isSubscribed = false;
          productDetail.skus.forEach(element => {
            if (subResponse[element.socCode] === 'false') {
              isSubscribed = true;
            }
          });
          if (isSubscribed) {
            this.router.navigate(['browse/details/' + productId]);
          } else {
            this.router.navigate([sourceRoute]);
          }
        }, error => {
          if (error.status === 400) {
            if (JSON.stringify(error.error[0]).indexOf('COMPANY_NOT_FOUND') !== -1) {
              console.log('compnay id invalid.');
            }
          }
          this.router.navigate([sourceRoute]);
        });
    } else {
      this.router.navigate([sourceRoute]);
    }
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
    // Alert initialization on login
    const event = document.createEvent('Event');
    event.initEvent('userLogged', true, true);
    document.dispatchEvent(event);
  }

  private getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'AWAITING_SIGNUP'; }).length;
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else if (signedUpFansCount === 0) {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

  deleteFaqSupportCookies(cookieName) {
    let d = new Date();
    d.setTime(d.getTime());
    let expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=true; expires=" + expires + "; domain=.att.com; path=/";
  }

}

